<div class="wrapper">
  @for (p of countdownParts$ | async | keyvalue; track trackByFn($index, p)) {
    <div
      [ngClass]="segmentLabel === 'long' ? 'long-labels' : 'short-labels'"
      class="segment">
      <span class="num subtitle">{{ p.value }}</span>
      <span class="label footnote">{{ segmentLabels[p.key] }}</span>
    </div>
  }
</div>
